import React from "react";
import "pages/pickers/Pickers.scss";
import { HeaderDescription, Tabs } from "@pickit/pickit-components";
import FilterPickers from "pages/pickers/filter/FilterContainer";
import { TablePickers } from "./TablePickers/TablePIckers";
import { PickerTypes } from "./types";
import { pickerTabs } from "./types";
import { useTranslation } from "react-i18next";
import "./i18n";
import { ACTIVE_PICKER_STATUS } from "utils/constants";
import { AlignTypes } from "@pickit/pickit-components/dist/Tabs/types";

const tabIds: pickerTabs[] = ["pending", "pickers"];

export const Pickers: React.FC<PickerTypes> = ({
  actualPage,
  pendingUsers,
  filters,
  filtersExtraSeeMore,
  seeMore,
  getMorePendingUser,
  getPendingUsersExportRequest,
  testId,
  collapseTable,
  changePage,
}): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="header-description-container">
        <HeaderDescription
          headline="Flota"
          overline="Reportes"
          testId={`${testId}-title`}
        />
      </div>
      <Tabs
        tabs={[
          { title: t("pickers:pending"), icon: "warning", testId: "pickers-tab-pending" },
          { title: t("pickers:pickers"), icon: "motorbike", testId: "pickers-tab-active" },
        ]}
        initialIndex={tabIds.indexOf(actualPage)}
        onChange={(action, index) => {
          action();
          changePage(tabIds[index ?? 0]);
        }}
        align={'left' as AlignTypes}
        size="large"
        width="25%"
      >
        <>
          <>
            <FilterPickers testId={`${testId}-filters`} actualPage="pending" />
            <TablePickers
              actualPage="pending"
              pendingUsers={pendingUsers}
              testId={`${testId}-table`}
              seeMore={seeMore}
              collapseTable={collapseTable}
              getMorePickers={() =>
                getMorePendingUser({
                  ...filters,
                  ...filtersExtraSeeMore,
                  identificationType: filters.identificationType?.tag,
                  vehicleType: filters.vehicleType || undefined,
                  status: filters.status || ACTIVE_PICKER_STATUS.join(","),
                })
              }
            />
          </>
          <>
            <FilterPickers testId={`${testId}-filters`} actualPage="pickers" />
            <TablePickers
              actualPage="pickers"
              pendingUsers={pendingUsers}
              testId={`${testId}-table`}
              seeMore={seeMore}
              collapseTable={collapseTable}
              getMorePickers={() =>
                getMorePendingUser({
                  ...filters,
                  ...filtersExtraSeeMore,
                  identificationType: filters.identificationType?.tag,
                  vehicleType: filters.vehicleType || undefined,
                  status: filters.status || ACTIVE_PICKER_STATUS.join(","),
                })
              }
            />
          </>
        </>
      </Tabs>
    </div>
  );
};
